/** Sentry environment for real users. The Sentry gate filters on it. */
export const PRODUCTION_SENTRY_ENVIRONMENT = "production";

/**
 * Sentry environment for our own QA robot (e2e-live, `npm run test:live`).
 * The robot runs against production, so its errors must stay out of the
 * "production" environment.
 */
export const QA_ROBOT_SENTRY_ENVIRONMENT = "qa-robot";

/** Flag that the e2e-live fixture sets on every robot page. */
export const QA_ROBOT_WINDOW_FLAG = "__CAP_QA_ROBOT__";

type SentryEnvironmentWindow = {
  navigator?: { webdriver?: boolean };
  [QA_ROBOT_WINDOW_FLAG]?: unknown;
};

/**
 * A page is a robot page when the browser is under automation
 * (navigator.webdriver, set by Playwright and WebDriver) or when the robot
 * fixture marked the page.
 */
export const isQaRobotBrowser = (win?: SentryEnvironmentWindow): boolean => {
  try {
    return Boolean(win?.navigator?.webdriver) || win?.[QA_ROBOT_WINDOW_FLAG] === true;
  } catch {
    return false;
  }
};

export const getSentryEnvironment = (
  win: SentryEnvironmentWindow | undefined = typeof window === "undefined"
    ? undefined
    : (window as unknown as SentryEnvironmentWindow)
): string =>
  isQaRobotBrowser(win) ? QA_ROBOT_SENTRY_ENVIRONMENT : PRODUCTION_SENTRY_ENVIRONMENT;
